import type { RouteObject } from 'react-router-dom';
import Layout from '@/app/Layouts/Layout';
import ConditionalHomePage from '@/app/router/ConditionalHomePage';
import { homeSeo } from '@/features/home/presentation/page/home.seo';
import { recentlyViewedSeo } from '@/pages/product-listing/recentlyViewed.seo';
import { searchImageSeo } from '@/pages/product-listing/searchImage.seo';
import { IMAGE_SEARCH_PAGE_PATH } from '@/features/search/constants';
import BrowsePlpPage from '@/pages/product-listing/BrowsePlpPage';
import SearchPlpPage from '@/pages/product-listing/SearchPlpPage';
import ImageSearchPlpPage from '@/pages/product-listing/ImageSearchPlpPage';
import StorePlpPage from '@/pages/product-listing/StorePlpPage';
import RecentlyViewedPlpPage from '@/pages/product-listing/RecentlyViewedPlpPage';
import { PlpNoResults } from '@/features/plp/presentation/components/PlpNoResults';
import PosApprovalPage from '@/features/pos-approval/presentation/page/PosApprovalPage';
import PendingAddressPage from '@/pages/post-order-address/PendingAddressPage';
import SignzyStatusPage from '@/features/signzy/presentation/page/SignzyStatusPage';
import WorkflowLayout from '../Layouts/WorkflowLayout';
import CheckoutFlowRouteLayout from '../Layouts/CheckoutFlowLayout';
import ProductDetailPage from '@/pages/product-detail/ProductDetailPage';
import PayViaLinkPage from '@/pages/pay-via-link';
import PaymentContextPage from '@/pages/payment-context';
import PaymentContextPollingPage from '@/pages/payment-context/polling';
import PayViaLinkSuccessPage from '@/pages/pay-via-link/success';
import PayViaLinkFailurePage from '@/pages/pay-via-link/failure';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <ConditionalHomePage />,
        handle: { routeSeo: homeSeo },
      },
      // Jewellery browse PLP routes
      {
        path: 'jewellery/filter/:pageId/:tagString.html',
        element: <BrowsePlpPage />,
      },
      {
        path: 'jewellery/filter/:tagString.html',
        element: <BrowsePlpPage />,
      },
      {
        path: 'jewellery/:pageId/:tagString.html',
        element: <BrowsePlpPage />,
      },
      {
        path: 'jewellery/:pageId([0-9]+).html',
        element: <BrowsePlpPage />,
      },
      {
        path: 'jewellery/:tagString.html',
        element: <BrowsePlpPage />,
      },
      {
        path: 'jewellery.html',
        element: <BrowsePlpPage />,
      },
      // Search PLP routes
      {
        path: IMAGE_SEARCH_PAGE_PATH.slice(1),
        element: <ImageSearchPlpPage />,
        handle: { routeSeo: searchImageSeo },
      },
      {
        path: 'search/:pageId([0-9]+)',
        element: <SearchPlpPage />,
      },
      {
        path: 'search',
        element: <SearchPlpPage />,
      },
      // Store catalogue PLP routes
      {
        path: 'stores/:cityStorePlaceholder-reslnk-:sid/catalog/filter/:tagString.html',
        element: <StorePlpPage />,
      },
      {
        path: 'stores/:cityStorePlaceholder-reslnk-:sid/catalog/:tagString.html',
        element: <StorePlpPage />,
      },
      {
        path: 'stores/:cityStorePlaceholder-reslnk-:sid/catalog.html',
        element: <StorePlpPage />,
      },
      {
        path: 'stores/:cityName/catalog/filter/:tagString.html',
        element: <StorePlpPage />,
      },
      {
        path: 'stores/:cityName/catalog/:tagString.html',
        element: <StorePlpPage />,
      },
      {
        path: 'stores/:cityName/catalog.html',
        element: <StorePlpPage />,
      },
      {
        path: 'plp',
        element: <BrowsePlpPage />,
      },
      {
        path: 'recently-viewed',
        element: <RecentlyViewedPlpPage />,
        handle: { routeSeo: recentlyViewedSeo },
      },
      {
        path: 'recently-viewed',
        element: <RecentlyViewedPlpPage />,
        handle: { routeSeo: recentlyViewedSeo },
      },
      {
        path: 'order/address/pending',
        element: <PendingAddressPage />,
      },
      {
        path: 'order/address/secure/pending',
        element: <PendingAddressPage />,
      },
      // PDP catch-all — must be after all PLP routes
      {
        path: ':category/:productSlug',
        element: <ProductDetailPage />,
      },
      {
        path: '*',
        element: <PlpNoResults />,
      },
    ],
  },
  {
    element: <WorkflowLayout />,
    children: [
      {
        path: 'pcl',
        element: <PosApprovalPage />,
        handle: {subtitle: 'Login Approval'}
      },
      {
        path: 'src',
        element: <SignzyStatusPage />,
        handle: {subtitle: ''}
      }
    ]
  
  },
  {
    element: <CheckoutFlowRouteLayout />,
    children: [
      {
        path: 'payvialink',
        children: [
          {
            path: ':token',
            element: <PayViaLinkPage />,
            handle: { checkoutLayout: false },
          },
          {
            path: 'success',
            element: <PayViaLinkSuccessPage />,
          },
          {
            path: 'failure',
            element: <PayViaLinkFailurePage />,
            handle: { checkoutLayout: false },
          },
        ],
      },
      {
        path: 'payment-context',
        children: [
          {
            index: true,
            element: <PaymentContextPage />,
            handle: { checkoutLayout: false },
          },
          {
            path: 'call-back/:encryptedTxnId',
            element: <PaymentContextPollingPage />,
            handle: { checkoutLayout: false },
          },
          {
            path: 'success',
            element: <PayViaLinkSuccessPage />,
          },
          {
            path: 'failure',
            element: <PayViaLinkFailurePage />,
            handle: { checkoutLayout: false },
          },
        ],
      },
      {
        path: 'razorpay/call-back/v2/:encryptedTxnId',
        element: <PaymentContextPollingPage />,
        handle: { checkoutLayout: false },
      },
    ],
  },
];
